import React from 'react';
import { cn } from '@/lib/utils';
import Icon, { IconComponent } from './Icon';

interface ResultStateProps {
  tone: 'success' | 'danger' | 'warning' | 'info';
  icon: IconComponent;
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Heading level; use h2 when the page already has a title. */
  as?: 'h1' | 'h2';
  className?: string;
}

const tones = {
  success: { circle: 'tw-bg-ds-success-bg', icon: 'tw-text-ds-text-secondary' },
  danger: { circle: 'tw-bg-ds-danger-bg', icon: 'tw-text-ds-danger-fg' },
  warning: { circle: 'tw-bg-ds-warning-bg', icon: 'tw-text-ds-warning-fg' },
  info: { circle: 'tw-bg-ds-info-bg', icon: 'tw-text-ds-info-fg' },
};

/** Centered success/error state. Always follow it with a clear next-action button. */
const ResultState: React.FC<ResultStateProps> = ({ tone, icon, title, description, as: Heading = 'h1', className }) => (
  <div className={cn('tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-3 tw-py-2 tw-text-center', className)}>
    <div className={cn('tw-flex tw-h-[72px] tw-w-[72px] tw-items-center tw-justify-center tw-rounded-full', tones[tone].circle)}>
      <Icon icon={icon} size={34} className={tones[tone].icon} />
    </div>
    <Heading className="tw-text-[24px] tw-font-bold tw-leading-[30px] tw-tracking-[-0.24px] tw-text-ds-text-primary">{title}</Heading>
    {description && <p className="tw-text-[15px] tw-leading-[22px] tw-text-ds-text-secondary">{description}</p>}
  </div>
);

export default ResultState;
